import { useEffect, useState } from 'react';
import Modal from '../../components/common/Modal';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import ErroCarregamento, { extrairMensagemErro } from '../../components/common/ErroCarregamento';
import StatusBadge from '../../components/common/StatusBadge';
import { formatDateOnly } from '../../utils/date';
import * as avaliacoesApi from '../../api/avaliacoes';

export default function HistoricoModal({ idHospital, requisito, onClose }) {
  const [historico, setHistorico] = useState(null);
  const [erro, setErro] = useState('');

  const carregar = async () => {
    setErro('');
    try {
      const { data } = await avaliacoesApi.listarHistorico(idHospital, requisito.id_requisito);
      setHistorico(data);
    } catch (err) {
      setErro(extrairMensagemErro(err, 'Não foi possível carregar o histórico.'));
    }
  };

  useEffect(() => {
    carregar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idHospital, requisito.id_requisito]);

  return (
    <Modal titulo={`Histórico — ${requisito.codigo}`} onClose={onClose} largura={600}>
      {!historico ? (
        erro ? <ErroCarregamento mensagem={erro} onRetry={carregar} /> : <LoadingSpinner />
      ) : historico.length === 0 ? (
        <div className="empty-state">
          <div className="ms">history</div>
          <div>Nenhuma avaliação registrada ainda para este requisito.</div>
        </div>
      ) : (
        <div className="d-flex flex-column gap-3">
          {historico.map((h) => (
            <div key={h.id_avaliacao} style={{ borderBottom: '1px solid var(--am-borda-2)', paddingBottom: 12 }}>
              <div className="d-flex align-items-center justify-content-between mb-1">
                <StatusBadge status={h.status} />
                <span style={{ fontSize: 12, color: 'var(--am-cinza-texto-2)' }}>
                  {formatDateOnly(h.data_avaliacao)}
                </span>
              </div>
              {h.fragilidade && (
                <div style={{ fontSize: 13, marginTop: 4 }}>
                  <strong>Fragilidade:</strong> {h.fragilidade}
                </div>
              )}
              {h.acao_proposta && (
                <div style={{ fontSize: 13, marginTop: 4 }}>
                  <strong>Ação:</strong> {h.acao_proposta}
                </div>
              )}
              {h.prazo_acao && (
                <div style={{ fontSize: 13, marginTop: 4 }}>
                  <strong>Prazo:</strong> {formatDateOnly(h.prazo_acao)}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
}
